/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useTranslation } from 'react-i18next';

const MentoringProgram = () => {
    const { t } = useTranslation();
    let mobileView = false;
    if (window.innerWidth <= 820) mobileView = true;

    return (
        <div className="careerWam" style={{ backgroundColor: '' }} id="career_wam">
            {mobileView ?
                <>
                    <br style={{ marginTop: "2rem" }} />
                </>
                :
                <>
                    <br style={{ marginTop: "2rem" }} />
                    <div>
                        <div id="wamcorner">
                        </div>
                        <p id="wamcornertext">Free, Exclusive <br />Mentoring Program</p>
                    </div>
                </>
            }
            <div id="wamflex" >
                <div id="wam_img1" style={{ display: 'flex', justifyContent: 'center', marginTop: mobileView ? "0" : "2rem" }}>
                    {mobileView ?
                        <div style={{ backgroundColor: "black", lineHeight: "1rem", paddingTop: "0", justifySelf: 'start !important' }}>
                            <p style={{ color: "white", fontSize: "1rem", lineHeight: "1rem", marginBottom: "0", padding: "0.4rem" }}>Free, Exclusive Mentoring Program</p>
                        </div>
                        : null}
                    <img style={{ width: '100vw', maxWidth: mobileView ? "100%" : "85%", height: 'auto', display: 'block', margin: 'auto' }} src={mobileView ? "images/wam/assets-17.png" : "images/wam/assets-16.png"} />
                </div>
                <div>
                    <h2 style={{ textAlign: 'center', backgroundColor: '#ed1c24', color: 'white', fontWeight: 'bold', fontSize: '2.2rem', marginTop: "2rem", paddingTop: "0.5rem", marginLeft: "20%", paddingLeft: "1rem", marginRight: "20%", paddingRight: "1rem", paddingBottom: "0.5rem" }}>
                        Mentoring Program
                    </h2>
                    <h2 style={{ textAlign: 'center', color: 'black', fontWeight: 'bold', fontSize: mobileView ? '2.1rem' : '2.2rem', marginLeft: "5%", paddingLeft: "1rem", marginRight: "5%", paddingRight: "1rem", paddingBottom: "0.5rem" }}>
                        for Women in {mobileView ? <br /> : null}Asset Management
                    </h2>
                    <h2 style={{ textAlign: 'center', color: 'black', fontSize: '1.5rem', marginLeft: "5%", paddingLeft: "1rem", marginRight: "0.5rem", paddingRight: "1rem", paddingBottom: "0.5rem", marginBottom: "0.5rem" }}>
                        Empowering the Next Generation of Leaders
                    </h2>
                    {mobileView ?
                        <h2 style={{ textAlign: 'center', color: 'black', border: "2px solid black", fontSize: '1.2rem', paddingTop: "0.5rem", marginLeft: "5%", paddingLeft: "1rem", marginRight: "5%", paddingRight: "1rem", paddingBottom: "0.5rem", marginBottom: "0.5rem" }}>
                            <b>Calling all female university students studying <u>finance, economics, accounting, law, engineering</u> and related fields!</b>
                        </h2>
                        : null
                    }
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: "row", paddingLeft: "1rem", justifyContent: "center" }}>
                        <div style={{ flex: "12 0 0", display: "flex", padding: "1rem", justifyContent: "center", justifyItems: "center" }}>
                            <h2 style={{ textAlign: 'center', alignContent: "center", backgroundColor: "#ed1c24", color: 'white', fontSize: '1.5rem', fontWeight: "bold", padding: "0.5rem 1rem 0.5rem 1rem" }}>
                                Why Apply?
                            </h2>
                        </div>
                    </div>
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: mobileView ? "column" : "row", paddingLeft: "1rem", justifyContent: "center" }}>
                        <div className="wamFlexitem" style={{ flex: mobileView ? "12 0 0" : "4 0 0", padding: "1rem" }}>
                            <img style={{ width: '190px', maxWidth: "100%", height:"auto", display: 'block', margin: 'auto' }} src="images/wam/assets-18.png" />
                            <h2 style={{ fontWeight: "bold", fontSize: "1.5rem", lineHeight: "1.6rem" }}>
                                1:1 Mentorship
                            </h2>
                            <p style={{ fontSize: "1.2rem", paddingRight: "1rem", lineHeight: "1.6rem" }}>
                                Get 1:1 guidance from seasoned asset management professionals on career planning, technical skills, and more—whenever you need it.
                            </p>
                        </div>
                        <div className="wamFlexitem" style={{ flex: mobileView ? "12 0 0" : "4 0 0", padding: "1rem" }}>
                            <img style={{ width: '190px', maxWidth: "100%", height:"auto", display: 'block', margin: 'auto' }} src="images/wam/assets-19.png" />
                            <h2 style={{ fontWeight: "bold", fontSize: "1.5rem", lineHeight: "1.6rem" }}>
                                Real-World
                                Exposure
                            </h2>
                            <p style={{ fontSize: "1.2rem", paddingRight: "1rem", lineHeight: "1.6rem" }}>
                                Gain industry
                                knowledge and
                                insights.
                            </p>
                        </div>
                        <div className="wamFlexitem" style={{ flex: mobileView ? "12 0 0" : "4 0 0", padding: "1rem" }}>
                            <img style={{ width: '190px', maxWidth: "100%", height:"auto", display: 'block', margin: 'auto' }} src="images/wam/assets-20.png" />
                            <h2 style={{ fontWeight: "bold", fontSize: "1.5rem", lineHeight: "1.6rem" }}>
                                Drop-In
                                Networking
                            </h2>
                            <p style={{ fontSize: "1.2rem", paddingRight: "1rem", lineHeight: "1.6rem" }}>
                                Join coffee chats
                                or events —
                                attend as often as
                                you like.
                            </p>
                        </div>
                    </div>

                    <h2 style={{ color: 'black', fontWeight: 'bold', fontSize: '1.7rem', paddingLeft: "1rem", marginRight: "5%", paddingRight: "1rem", paddingBottom: "0.5rem" }}>
                        Launch Your Career in Asset Management!
                    </h2>
                    <br />
                    <h2 style={{ color: 'black', fontWeight: 'bold', fontSize: '1.5rem', paddingLeft: "1rem", marginRight: "5%", paddingRight: "1rem", paddingBottom: "0.5rem" }}>
                        Program Highlights
                    </h2>
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: "row", paddingLeft: "1rem" }}>
                        <div className="wamFlexitem " style={{ flex: "2 0 0", padding: "1rem 0rem 1rem 0rem" }}>
                            <p style={{ fontWeight: "bold", border: "1px solid black", textAlign: "center", paddingLeft: "2px", paddingRight: "2px" }}>
                                Duration
                            </p>
                        </div>
                        <div className="wamFlexitem " style={{ flex: "10 0 0", padding: "1rem", lineHeight: "1.2rem" }}>
                            <p>
                                12 months (flexible around academic commitments)
                            </p>
                        </div>
                    </div>
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: "row", paddingLeft: "1rem" }}>
                        <div className="wamFlexitem " style={{ flex: "2 0 0", padding: "1rem 0rem 1rem 0rem" }}>
                            <p style={{ fontWeight: "bold", border: "1px solid black", textAlign: "center", paddingLeft: "2px", paddingRight: "2px" }}>
                                Format
                            </p>
                        </div>
                        <div className="wamFlexitem " style={{ flex: "10 0 0", padding: "1rem", lineHeight: "1.2rem" }}>
                            <p>
                                Mentorship meetings + coffee chats
                            </p>
                        </div>
                    </div>
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: "row", paddingLeft: "1rem" }}>
                        <div className="wamFlexitem " style={{ flex: "2 0 0", padding: "1rem 0rem 1rem 0rem" }}>
                            <p style={{ fontWeight: "bold", border: "1px solid black", textAlign: "center", paddingLeft: "2px", paddingRight: "2px" }}>
                                Eligibility
                            </p>
                        </div>
                        <div className="wamFlexitem " style={{ flex: "10 0 0", padding: "1rem", lineHeight: "1.2rem" }}>
                            <p>
                                Open to female university students in Malaysia, Hong Kong,
                                China, and Australia
                            </p>
                        </div>
                    </div>
                    <br />
                    <h2 style={{ color: 'black', fontWeight: 'bold', fontSize: '1.5rem', paddingLeft: mobileView ? "5vw" : "1rem", marginRight: "5%", paddingRight: "1rem", paddingBottom: "0.5rem" }}>
                        Meet Your Mentors

                    </h2>
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: "column" }}>
                        <div className='wamFlexitem' style={{ flex: "12 0 0", padding: "1rem 0.5rem 1rem 0.5rem", display: "flex", flexDirection: mobileView ? "column" : "row", justifyContent: mobileView ? "center" : "" }}>
                            <div className='wamFlexitem' style={{ flex: mobileView ? "12 0 0" : "6 0 0", padding: "1rem 1rem 0 1rem" }}>
                                <img style={{ width: 'auto', height: '120px', display: 'block', margin: 'auto' }} src="images/wam/assets-25.png" />
                            </div>
                            <div className='wamFlexitem' style={{ flex: mobileView ? "12 0 0" : "6 0 0", padding: "1rem 1rem 0 1rem", paddingLeft: mobileView ? "15vw" : "" }}>
                                <ul style={{ listStyle: "circle !important", display: "flex", justifyContent: "space-around", flexDirection: "column" }}>
                                    <li>
                                        <p style={{ paddingBottom: "0.5rem", margin: "0", lineHeight: "1.2rem" }}>
                                            <b style={{ fontSize: "1.1rem" }}>
                                                {mobileView ? "" : "• "}
                                                Deputy Group CEO,</b>
                                            <br /><i style={{ fontSize: "1rem" }}>
                                                {mobileView ? "" : "\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                                Capital Dynamics</i>
                                        </p>
                                    </li>
                                    <br />
                                    <li>
                                        <p style={{ paddingBottom: "0.5rem", margin: "0", lineHeight: "1.2rem" }}>
                                            <b style={{ fontSize: "1.1rem" }}>
                                                {mobileView ? "" : "• "}
                                                Director,</b>
                                            <br /><i style={{ fontSize: "1rem" }}>
                                                {mobileView ? "" : "\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                                icapital.biz Berhad,
                                                <br />
                                                {mobileView ? "" : "\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                                Bursa-listed closed end fund</i>
                                        </p>
                                    </li>
                                    <br />
                                    <li>
                                        <p style={{ paddingBottom: "0.5rem", margin: "0", lineHeight: "1.2rem" }}>
                                            {mobileView ? "" : "• "}
                                            <b style={{ fontSize: "1.1rem" }}>
                                                Licensed Fund Manager</b>
                                            <br /><i style={{ fontSize: "1rem" }}>
                                                {mobileView ? "" : "\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                                in Hong Kong & Malaysia</i>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='wamFlexitem' style={{ flex: "12 0 0", padding: "1rem 0.5rem 1rem 0.5rem", display: "flex", flexDirection: mobileView ? "column" : "row", justifyContent: mobileView ? "center" : "" }}>
                            <div className='wamFlexitem' style={{ flex: mobileView ? "12 0 0" : "6 0 0", padding: "1rem 1rem 0 1rem" }}>
                                <img style={{ width: 'auto', height: '120px', display: 'block', margin: 'auto' }} src="images/wam/assets-26.png" />
                            </div>
                            <div className='wamFlexitem' style={{ display: "flex", flex: mobileView ? "12 0 0" : "6 0 0", padding: "1rem 1rem 0 1rem", paddingLeft: mobileView ? "15vw" : "", alignContent: "center" }}>
                                <ul style={{ listStyle: "circle !important", display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                    <li>
                                        <p style={{ paddingBottom: "0", margin: "0", lineHeight: "1.2rem" }}>
                                            <b style={{ fontSize: "1.1rem" }}>
                                                {mobileView ? "" : "• "}
                                                Executive Director,
                                            </b>
                                            <br /><i style={{ fontSize: "1rem" }}>
                                                {mobileView ? "" : "\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                                Capital Dynamics
                                            </i>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <h2 style={{ color: 'black', fontWeight: 'bold', fontSize: '1.5rem', paddingLeft: "1rem", marginRight: "5%", paddingRight: "1rem", paddingBottom: "0.5rem" }}>
                        How to Apply

                    </h2>
                    <div className='wamFlexbox' style={{ display: "flex", flexDirection: mobileView ? "column" : "row" }}>
                        <div className="wamFlexitem " style={{ flex: "7 0 0", padding: "0 1rem 0 1rem" }}>
                            <h2 style={{ color: 'black', fontWeight: 'bold', fontSize: mobileView ? '1rem' : '1.2rem', marginRight: "5%", paddingRight: "1rem" }}>
                                Submit Your CV + Personal Statement :
                            </h2>
                            <p style={{ color: 'black', fontSize: mobileView ? '1rem' : '1.2rem', marginRight: "5%", paddingRight: "1rem", lineHeight: "1.2rem" }}>
                                Tell us about your mentorship goals and
                                why you should be selected to join.
                            </p>
                        </div>
                        <div className="wamFlexitem " style={{ flex: "5 0 0", padding: "1rem 1rem 0 1rem", justifyContent: "center" }}>
                            <a href="mailto:careers@cdam.biz" style={{ backgroundColor: "black", color: "white", fontSize: "1.5rem", fontWeight: "bold", padding: "1rem", textAlign: 'center' }}>
                                careers@cdam.biz
                            </a>
                        </div>
                    </div>
                    <div className="wamFlexitem " style={{ flex: "12 0 0", padding: "0 1rem 0 1rem", justifyContent: "center" }}>
                        <p style={{ color: 'black', fontSize: '1.2rem', paddingTop: "0.5rem", marginRight: "5%", paddingRight: "1rem", lineHeight: "1.2rem" }}>
                            <b>Rolling Deadlines: </b>
                            No cut-off dates— apply now or later.
                        </p>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default MentoringProgram;

